import { isDeepEmpty } from '@takeshape/util';
import { fromJS } from 'immutable';
import { createReducer } from 'typesafe-actions';
import { isImmutableList, isImmutableRecord } from '../common/utils/immutable-type-util.js';
import type { ImmutableMap } from '../common/utils/immutable-types.js';
import { REMOVE_ARRAY_ITEM } from '../schema-form/action-types.js';
import type { RemoveArrayItemAction } from '../schema-form/actions.js';
import type { FormState } from '../schema-form/types.js';
import { GUARD_FORM_NAME } from './constants.js';

type State = ImmutableMap<FormState>;

export function removeArrayItem(state: State, { meta }: RemoveArrayItemAction): State {
  const modifiedArray = state.getIn(['data', ...meta.path]);

  if (isImmutableList(modifiedArray) && modifiedArray.size === 0) {
    if (meta.path.length > 1) {
      const parentKey = meta.path.slice(0, -1);
      const modifiedParent = state.getIn(['data', ...parentKey]);
      if (isImmutableRecord(modifiedParent) && isDeepEmpty(modifiedParent.toJS())) {
        return state.removeIn(['data', ...parentKey]);
      }
    }

    return state.removeIn(['data', ...meta.path]);
  }

  return state;
}

export const guardrailsFormReducers = {
  [GUARD_FORM_NAME]: createReducer<State, RemoveArrayItemAction>(fromJS({})).handleType(
    REMOVE_ARRAY_ITEM,
    removeArrayItem
  )
};
